import React from 'react'
import DestroyedListTable from './Components/DestroyedListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const DestroyedList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Destroyed Items List</HeadingOne>
          <AddItemBtn url="add-destroyed-list" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <DestroyedListTable />
      </div>
    </PageBody>
  );
};

export default DestroyedList;
